<!--人文美育-视频库管理-->
<template>
    <div class="app-container" >
        <div class="parent-container">
            <!--目录-->
            <div class="l-container">
                <div class="l-top-container">
                    <div class="l-box">目录</div>
                    <div class="r-box cursor">
                        <div style="margin-top: 4px;" @click="handleSyncData">
                            <svg t="1755064394245" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7145" width="20" height="20"><path d="M512 896c-51.83 0-102.12-10.16-149.48-30.19-45.73-19.34-86.79-47.03-122.05-82.28-35.26-35.26-62.94-76.32-82.28-122.05a382.894 382.894 0 0 1-14.86-41.67l-9.55 19.71c-3.85 7.95-13.42 11.28-21.38 7.42l-28.8-13.95c-7.95-3.85-11.28-13.42-7.42-21.38L161.6 435.3c7.41-15.29 30.4-10.02 30.4 6.98v67.59C192 686.78 336.76 832.9 513.67 832c79.76-0.41 154.97-29.81 213.58-83.2 6.31-5.75 16.03-5.51 22.06 0.53l22.65 22.65c6.46 6.46 6.18 16.98-0.55 23.16-32.44 29.77-69.35 53.51-109.94 70.68C614.12 885.84 563.83 896 512 896zM832 579.88v-65.75C832 337.21 687.24 191.1 510.33 192c-79.76 0.41-154.97 29.81-213.58 83.2-6.31 5.75-16.03 5.51-22.06-0.53l-22.65-22.65c-6.46-6.46-6.18-16.98 0.55-23.16 32.44-29.77 69.35-53.51 109.94-70.68C409.88 138.16 460.17 128 512 128s102.12 10.16 149.48 30.19c45.73 19.34 86.79 47.03 122.05 82.28 35.25 35.26 62.94 76.32 82.28 122.05a384.37 384.37 0 0 1 15.37 43.42l11.04-22.12c3.95-7.91 13.55-11.12 21.46-7.17l28.63 14.29c7.91 3.95 11.12 13.55 7.17 21.46l-87.17 174.63c-7.54 15.11-30.31 9.74-30.31-7.15z" p-id="7146" fill="#676767"></path></svg>
                        </div>
                        <div style="text-indent: 2px;" @click="handleSyncData">同步数据</div>
                    </div>
                </div>
                <div class="l-second-container">
                    <div class="second-box1">
                        <svg t="1755139711785" style="margin-top: 3px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17744" width="16" height="16"><path d="M0 1024V128h256V0h128v128h256V0h128v128h256v896H0zM924.384 227.616H99.616v696.768h824.768V227.616z m-578.048 185.6l125.12 349.152h-83.2l-23.104-71.84H234.496l-23.136 71.84H128l125.12-349.152h93.216z m-1.952 213.696l-44.64-138.336-44.608 138.336h89.248z m235.648 66.048h106.496v69.408H512V413.12h68.032v279.744z m192 0h106.528v69.408H704V413.12h68.032v279.744z" fill="#ff7f2e" p-id="17745"></path></svg>
                    </div>
                    <div class="second-box2 cursor" @click="handleAllVideo">所有视频</div>
                    <div class="second-box3 cursor" @click="handleAllVideo">{{treeData.videoNum}}</div>
                </div>
                <el-scrollbar class="l-tree-container">
                    <el-tree
                      :data="categoryList"
                      :show-expand="true"
                      style="max-width: 240px;"
                      @node-click="handleNodeClick">
                        <template #default="{ node, data }">
                            <div class="custom-tree-node" :title="charConversion(data.categoryName)">
                                <div>
                                    <i>
                                        <svg t="1755142425021" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20345" width="16" height="16"><path d="M861.9 843.5c0 31.1-25.2 56.2-56.2 56.2H103.5l98.3-454.2c0-31 25-56.2 56.1-56.2h646.2c31 0 56.1 25.2 56.1 56.2l-98.3 398zM215.8 347.1h632v-55.2c0-31-25.2-56.2-56.2-56.2h-337v-50.9c0-31-25.2-56.2-56.2-56.2H117.6c-31 0-56.2 25.2-56.2 56.2v658.6l98.2-440.2c0-30.9 25.2-56.1 56.2-56.1z m0 0" p-id="20346" fill="#e99d42"></path></svg>
                                    </i>
                                    <span>{{charConversion(data.categoryName)}}</span>
                                </div>
                                <div>
                                    <el-button type="primary" style="color: #606266;margin-left: 5px;" link>{{data.videoNum}}</el-button>
                                </div>
                            </div>
                        </template>
                    </el-tree>
                </el-scrollbar>
            </div>
            <!--视频列表-->
            <div class="r-container">
                <div class="form-box">
                    <el-form ref="queryForm"
                             :model="queryParams"
                             :inline="true"
                             label-width="90px">
                        <el-row >
                            <el-col :span="8">
                                <el-form-item label="设置标签">
                                    <el-select clearable @change="queryHumanityVideo()" v-model="queryParams.isTag" placeholder="请选择">
                                        <el-option v-for="item in tagList" :key="item.value" :label="item.name"
                                                   :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="关联课程库">
                                    <el-select clearable @change="queryHumanityVideo()" v-model="queryParams.isCourse" placeholder="请选择">
                                        <el-option v-for="item in courseList" :key="item.value" :label="item.name"
                                                   :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="pull-right">
                                    <el-input v-model="queryParams.title" placeholder="请输入视频名称" class="input-with-select">
                                        <template #append>
                                            <el-button type="primary" @click="handleQuery" style="background-color: #ff7f2e;color: #fff" icon="el-icon-search" />
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <div class="bre9e mt5">
                    <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                              height="calc(100vh - 215px)"
                              :data="dataList"
                              highlight-current-row>
                        <el-table-column type="index" align="center" label="序号" width="60" />
                        <el-table-column width="80px" align="center" label="封面" prop="coverUrl">
                            <template #default="scope">
                                <img alt="" :src="scope.row.coverUrl" width="40" height="22" class="cursor" style="margin-top: 5px"/>
                            </template>
                        </el-table-column>
                        <el-table-column width="220px" align="center" label="视频名称" prop="title">
                            <template #default="scope">
                                <div :title="scope.row.title" @click="viewVideo(scope.row)" style="color: #409efe;" class="text-one cursor">
                                    {{ scope.row.title }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="120px" align="center" label="时长" prop="duration">
                            <template #default="scope">
                                <div>{{ formatSecondDate(scope.row.duration)}}</div>
                            </template>
                        </el-table-column>
<!--                        <el-table-column width="120px" align="center" label="VID" prop="videoId">-->
<!--                        </el-table-column>-->
                        <el-table-column width="140px" align="center" label="上传时间" prop="creationTime">
                            <template #default="scope">
                                <div>{{ moment(scope.row.creationTime).format("YYYY-MM-DD hh:mm")}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column width="120px" align="center" label="标签" prop="tags">
                        </el-table-column>
                        <el-table-column fixed="right" width="100" label="操作" align="center">
                            <template #default="scope">
                                <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="zdyfy">
                    <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]"  :total="total"
                                :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="queryHumanityVideo" />
                </div>
            </div>
        </div>
    </div>


    <el-dialog class="ar-dialog" :title="videoName" v-model="isViewVideoShow"
               top="8vh"
               width="830px" @close="destroyed">
        <div id="player"></div>
    </el-dialog>

    <el-dialog class="ve-dialog" :title="'编辑视频信息'"
               v-model="isEditVideoShow"
               width="540px" >
        <div class="v-title">标签</div>
        <div class="tag-container">
            <div class="tag-box" v-if="vTagList&&vTagList.length>0">
                <el-tag type="primary" style="margin-right: 10px;margin-bottom: 10px" @close="delTag(tag)" v-for="tag in vTagList" closable>
                    {{ tag }}
                </el-tag>
            </div>
            <div class="zero-tag-box" v-if="!vTagList||vTagList.length===0">
                暂无标签
            </div>
        </div>
        <div class="create-tag-container">
            <el-input class="tag-input" style="height: 30px;" v-model="tagName" placeholder="请输入标签名称"/>
            <el-button type="primary" style="margin-left: 10px;height: 30px;" size="small" @click="addTag">添加标签</el-button>
        </div>
<!--        <div class="v-title">关联课程</div>-->
<!--        <div class="book-container">-->
<!--            <el-cascader style="width: 90%" :options="bookTree"-->
<!--                         v-model="videoForm.courseInfo"-->
<!--                         :props="props" clearable filterable placeholder="关键字搜索" />-->
<!--        </div>-->
        <div class="v-title" style="padding-top: 5px;padding-bottom: 5px;">视频资料</div>
        <el-upload v-model:file-list="fileList" class="upload-demo"
                   :action="serviceUrl+'/businessservice/humanityVideo/uploadFile'"
                   :on-change="handleChange" :headers="{ token }"
                   accept=".pdf,.ppt,.pptx,.doc,.docx"
                   :before-upload="beforeUpload">
            <el-button type="primary">点击上传</el-button>
            <template #tip>
                <div class="el-upload__tip">
                    只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                </div>
            </template>
        </el-upload>
        <template #footer>
            <div class="disflex-row-center">
                <el-button type="primary" @click="handleEditVideo">确 定</el-button>
                <el-button @click="isEditVideoShow=!isEditVideoShow">取 消</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import {formatSecondDate, timestampToTime} from "@/utils/date";
import {syncCategory,treeCategory,pageHumanityVideo,
    syncHumanityVideo,updateHumanityVideo} from "@/api/admin/humanity";
import {classLibraryListTreeNew} from "@/api/admin/classLibrary"
import {ElLoading} from "element-plus";
import moment from "moment"
import {serviceUrl} from "@/utils/global";
import {charConversion} from "@/utils/str"

export default {
    components: {},
    name: "videoLibraryManage",
    data() {
        return {
            charConversion,
            serviceUrl,
            loading:false,
            isViewVideoShow:false,
            isEditVideoShow:false,
            token: this.$storage.get("token"),
            timestampToTime,
            formatSecondDate,
            moment,
            treeList:{},
            treeData:{},
            categoryList:[],
            defaultProps: {
                children: 'children',
                label: 'categoryName',
            },
            total: 0,
            dataList: [],
            queryParams:{
                pageNum: 1,
                pageSize: 10,
                title: '',
                categoryId: '',
                isTag: '',
                isCourse: '',
            },
            tagList: [
                { name: '全部', value: '' },
                { name: '已设置', value: 1 },
                { name: '未设置', value: 0 },
            ],
            courseList: [
                { name: '全部', value: '' },
                { name: '已关联', value: 1 },
                { name: '未关联', value: 0 },
            ],
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoName:'',
            videoWidth:800,
            videoHeight:500,
            videoForm:{
                videoId:'',
                tags:'',
                courseInfo:[],
                itemInfo:[],
                fileUrls:'',
            },
            fileList:[],
            videoFormRules:{

            },
            tagName:'',
            vTagList:[],
            selBook: [],
            bookTree:[],
            props:{
                multiple: true,
                checkStrictly: true,
                label:'className',
                value:'classId',
                children:'childrenList'
            },
        }
    },
    computed: {
    },
    watch: {},
    created() {
        this.queryTreeCategory();
        this.queryHumanityVideo();
        // this.queryTreeBook();
    },
    mounted(){},
    methods: {
        handleSyncData(){
            this.handleSyncCategory();
            this.handleSyncVideo();
        },
        handleSyncCategory(){
            const loading = ElLoading.service({ fullscreen: true })
            syncCategory().then(res => {
                if (res.data.code===1){
                    this.queryTreeCategory();
                }else {
                    this.$message.error(res.data.msg);
                }
                loading.close();
            })
        },
        handleSyncVideo(){
            const loading = ElLoading.service({ fullscreen: true })
            syncHumanityVideo().then(res => {
                if (res.data.code===1){
                    this.queryHumanityVideo();
                }else {
                    this.$message.error(res.data.msg);
                }
                loading.close();
            })
        },
        queryTreeCategory(){
            treeCategory().then(res => {
                if (res.data.code===1){
                    if (res.data.data){
                        this.treeList= res.data.data;
                        this.treeData = this.treeList[0];
                        this.categoryList = this.treeData.children;
                    }
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleNodeClick(e, i){
            this.queryParams.categoryId=e.categoryId;
            this.queryParams.title = '';
            this.queryParams.isTag = '';
            this.queryParams.isCourse = '';
            this.queryHumanityVideo();
        },
        handleQuery(){
            this.queryHumanityVideo();
        },
        queryHumanityVideo(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageHumanityVideo(this.queryParams).then(res => {
                if (res.data.code===1){
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }else {
                    this.$message.error(res.data.msg);
                }
                this.loading = false;
            })
        },
        viewVideo(row){
            this.vid = row.videoId;
            this.videoName = row.title;
            this.isViewVideoShow = true;
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })

        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                width: this.videoWidth,
                height: this.videoHeight,
                vid: this.vid,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
            this.isViewVideoShow = false;
        },
        handleEdit(row){
            this.tagName = '';
            this.vTagList = [];
            this.fileList = [];
            this.videoForm.courseInfo = []
            this.videoForm.videoId = row.videoId;
            this.videoForm.tags = row.tags;
            if (row.fileList){
                row.fileList.forEach(e => {
                    this.fileList.push({
                        name: e.fileName,
                        fileId: e.fileId,
                        url: e.fileUrl,
                        response: {
                            code:1,
                            data: e.fileUrl
                        }
                    })
                })
            }
            if (row.courseInfo){
                this.videoForm.courseInfo = JSON.parse(row.courseInfo);
            }
            if (row.tags&&row.tags.length>0) {
                this.vTagList = row.tags.split(',');
            }
            this.isEditVideoShow = true;
        },
        handleAllVideo(){
            this.queryParams.categoryId='';
            this.queryHumanityVideo();
        },
        delTag(tag){
            this.vTagList.splice(this.vTagList.indexOf(tag), 1)
        },
        addTag(){
            if (!this.tagName){
                this.$message.error("请输入标签名称");
                return;
            }
            if (this.vTagList.includes(this.tagName)){
                this.$message.error("标签已存在");
                return;
            }
            this.vTagList.push(this.tagName);
            this.tagName = '';
        },
        handleEditVideo(){
            if (this.vTagList.length === 0&&this.fileList.length===0){
                this.$message.error("请添加标签或上传附件");
                return;
            }
            this.videoForm.tags = this.vTagList.join(",");
            this.videoForm.fileUrls = ''
            if (this.fileList&&this.fileList.length>0){
                const fileList = [];
                this.fileList.forEach((e) => {
                    if (e.response.code === 1) {
                        fileList.push(e.response.data);
                    }
                })
                this.videoForm.fileUrls = fileList.toString();
            }
            updateHumanityVideo(this.videoForm).then(res => {
                if (res.data.code===1){
                    this.queryHumanityVideo();
                }else {
                    this.$message.error(res.data.msg);
                }
            })
            this.isEditVideoShow = false;
        },
        queryTreeBook(){
            classLibraryListTreeNew().then(res => {
                if (res.data.code===1){
                    this.bookTree = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        handleChange(file) {},
        beforeUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
              rawFile.type === 'application/vnd.ms-powerpoint' ||
              rawFile.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
              rawFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
              rawFile.type === 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
    }
}

</script>

<style scoped>
.parent-container{
    height: calc(100vh - 85px);
    width: 100%;
    overflow-x: hidden!important;
    box-sizing: border-box;
    display: flex;
}
.l-container{
    width: 260px;
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
}
.l-top-container{
    width: 100%;
    height: 50px;
    padding: 10px 0 10px 0;
    line-height: 28px;
    box-sizing: border-box;
    border-bottom: 1.5px solid #f1f1f1;
    display: flex;
}
.l-box{
    width: 50%;
    height: 100%;
    line-height: 28px;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
    text-align: left;
    padding-left: 10px;
    color: #242424;
}
.r-box{
    width: 50%;
    height: 100%;
    font-size: 15px;
    font-family: sans-serif;
    text-align: right;
    padding-right: 10px;
    color: #676767;
    display: flex;
    justify-content: flex-end;
}
.l-second-container{
    width: 100%;
    height: 30px;
    padding: 0 10px 0 10px;
    line-height: 30px;
    box-sizing: border-box;
    display: flex;
}
.second-box1{
    width: 20px;
}
.second-box2{
    width: 100px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #ff7f2e;
}
.second-box3{
    width: calc(100% - 120px);
    line-height: 30px;
    text-align: right;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
    color: #ff7f2e;

}
.l-tree-container{
    width: 100%;
    height: calc(100% - 85px);
    padding: 0 0 0 10px;
    box-sizing: border-box;

}
.custom-tree-node{
    width: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
}
.tree-item-child1{
    width: 20px!important;
}
.tree-item-child2{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.tree-item-child3{
    width: 40px!important;
    text-align: right;
    display: flex;
    justify-content: flex-end;
}
.r-container{
    width: calc(100% - 270px);
    height: 100%;
    margin-left: 10px;
    background-color: #fff;
    border-radius: 4px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.form-box{
    padding-top: 20px;
}
.ar-form /deep/ .el-form-item{
    margin-bottom: 10px!important;
}
.ar-form /deep/ .el-form-item__label{
    color:#121212!important;
    font-weight:bold;
    font-size:15px
}

.ve-dialog /deep/ .el-dialog__header{
    height: 30px!important;
    padding-bottom: 0!important;
}

.v-title{
    font-family: sans-serif;
    font-size: 16px;
    color: #121212;
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-weight: 400;
}
.tag-input{
    width: 200px;
    height: 24px;
}
.create-tag-container{
    width: 100%;
    height: 30px;
    display: flex;

}
.zero-tag-box{
    height: auto;
    padding: 0 10px 0 10px;
}
.zero-tag-box{
    font-family: sans-serif;
    font-size: 14px;
    color: #666666;
    width: 100%;
    padding-bottom: 5px;
    text-align: left;
}
.v-tag{
    margin-right: 10px;
    margin-bottom: 5px;
    background-color: #a4adb3;
    color: #fff;
}
.book-container{
    width: 100%;
    height: auto;
}
.video-tag{
    margin-right: 10px;
    margin-bottom: 10px;
    //max-width: 200px;
    //overflow: hidden;
    //text-overflow: ellipsis;
    //white-space: nowrap;
}
</style>